import { User } from "@/app/core/entities/user.entity";
import { ELoadingStatus } from "@/app/core/models/loading-status.model";
import { Action, ActionReducer, createReducer, on } from "@ngrx/store";
import { loadCurrentUser, loadCurrentUserSuccess, loadCurrentUserFailure } from "./auth.actions";

export const AUTH_FEATURE_NAME = "AUTH_FEATURE";
export interface AuthState {
  businessId: string | null;
  user: {
    data: User | null;
    status: ELoadingStatus;
    error: string;
  };
}

const initialState: AuthState = {
  businessId: null,
  user: {
    data: null,
    status: ELoadingStatus.idle,
    error: null,
  },
};

let reducer: ActionReducer<any, Action>;
reducer = createReducer(
  initialState,
  on(loadCurrentUser, (state) => ({
    ...state,
    user: {
      data: null,
      status: ELoadingStatus.loading,
      error: null,
    },
  })),
  on(loadCurrentUserSuccess, (state, { user }) => ({
    ...state,
    user: {
      data: user,
      status: ELoadingStatus.loaded,
      error: null,
    },
    businessId: user?.businessUsers?.[0]?.business?.id,
  })),
  on(loadCurrentUserFailure, (state, { error }) => ({
    ...state,
    user: {
      data: null,
      status: ELoadingStatus.error,
      error,
    },
  }))
);

export function authReducer(state: AuthState, action: Action) {
  return reducer(state, action);
}
